<div class="documentBox">
<!-- Selection -->
<mat-card class="filter selection">
  <div class="sortview">
      Items Selected <span class="count">2</span>
  </div>
  <div class="selectact" >
      <button mat-button color="primary" (click)="addPI(PI)" ><mat-icon>link</mat-icon> Link PI</button>
      <button mat-button color="primary" ><mat-icon>delete_outline</mat-icon> Delete</button>       
    </div>
</mat-card>
<!-- Selection -->


<!-- Filter -->
<mat-card class="filter">
    <div class="sortview">
        <div class="sortby">
            
            <mat-form-field>
                <mat-label>Sort by</mat-label>
                <mat-select value="" >
                  <mat-option value="" >All</mat-option>
                  <mat-option value="">Started</mat-option>
                  <mat-option value="">Accepted</mat-option>
                  <mat-option value="" >Completed</mat-option>
                  <mat-option value="">Pending</mat-option>
                  <mat-option value="">Unavailable</mat-option>
                  <mat-option value="">Rescheduled</mat-option>
                  <mat-option value="" >Cancelled</mat-option>
                  <mat-option value="">Other</mat-option>
                </mat-select>
              </mat-form-field>
  
        </div>
        <!-- <div class="view_list">
            <button mat-icon-button  [ngClass]="{'active': list}" mat-icon-button (click)="showList()"  ><mat-icon>format_list_bulleted</mat-icon></button>
            <button mat-icon-button [ngClass]="{'active': grid}" (click)="showGrid()" ><mat-icon>apps</mat-icon></button>       
        </div> -->
    </div>
    <div class="actbtn" >
      <button mat-stroked-button color="primary"  (click)="addFolder(addFolderDialog)" >
        Add Folder
      </button>

        <button mat-flat-button color="primary" (click)="createNewTask(showCreateTask)" >
          Add Task
        </button>
      </div>
</mat-card>
<!-- Filter -->




<div Id="document" class="documents" >
  <mat-accordion>
    <mat-expansion-panel
      
      disabled="false"
      
    >
      <mat-expansion-panel-header>
        <mat-panel-title class="header">
          <div class="titleCount">
            <div class="folderName">
             Family
              <span class="count">2</span>
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="documentcontainer">
        <div class="stemplate">
          <button mat-icon-button [matMenuTriggerFor]="menu">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu" xPosition="before">
            <button
              mat-menu-item
              
            >
              <mat-icon>save</mat-icon> Save as Template
            </button>
            <button
              mat-menu-item
              
            >
              <mat-icon>library_add</mat-icon> Add Template
            </button>
         
            <button mat-menu-item >
              <mat-icon>delete</mat-icon> Remove Folder
            </button>
          </mat-menu>
        </div>
      
      </div>


      <mat-card class="table">
        <table class="mat-table">
          <tr class="mat-header-row">
            <th class="mat-header-cell w-60"><mat-checkbox color="primary" ></mat-checkbox></th>
            <th class="mat-header-cell w-60"></th>
            <th class="mat-header-cell">Name</th>
            <th class="mat-header-cell">Activity Type</th>
            <th class="mat-header-cell">Priority</th>
            <th class="mat-header-cell w-100">Due Date</th>
          </tr>
          <tr class="mat-row">
            <td class="mat-cell">
              <mat-checkbox color="primary" ></mat-checkbox>
            </td>
            <td class="mat-cell ">
            <button mat-icon-button class="setstatus" color="primary" ><mat-icon>check_circle</mat-icon></button>
            </td>
            <td class="mat-cell">
              <span class="taskname done" (click)="opentaskDetail(showTaskDetail)" >See a contact profile</span>           
              <button mat-icon-button  matTooltip="Process Intelligence" 
               matTooltipClass="tooltip" color="primary" class="mlr10" [matMenuTriggerFor]="appMenu" ><mat-icon>link</mat-icon></button>
              <mat-menu #appMenu="matMenu" xPosition="before" >
                <button mat-menu-item color="primary" class="linked" ><mat-icon>link</mat-icon> Real Estate PI linked</button>
                <button mat-menu-item  (click)="addPI(PI)" ><mat-icon>wrap_text</mat-icon> Replace PI</button>
                <button mat-menu-item><mat-icon>remove_circle_outline</mat-icon> Remove PI</button>
              </mat-menu>
              
              
    
            </td>
              
            <td class="mat-cell">
              To Do
            </td>
            <td class="mat-cell">
              <div class="fieldtype">
               ASAP
              </div>
            </td>
            <td class="mat-cell">
              11/05/2020
            </td>
            
          </tr>
          <tr class="mat-row">
            <td class="mat-cell ">
              <mat-checkbox color="primary" ></mat-checkbox>
            </td>
            <td class="mat-cell ">
            <button mat-icon-button class="setstatus" ><mat-icon>check_circle</mat-icon></button>
            </td>
            <td class="mat-cell">
              <span class="taskname" (click)="opentaskDetail(showTaskDetail)" >See how easy it is to customize Copper  </span>
              <button mat-icon-button class="unlinked"  (click)="addPI(PI)" matTooltip="Link Process Intelligence"  matTooltipClass="tooltip" >
                <mat-icon>link_off</mat-icon>
              </button>
            </td>
            <td class="mat-cell">
              To Do
            </td>
            <td class="mat-cell">
              <div class="fieldtype">
               ASAP
              </div>
            </td>
            <td class="mat-cell">
              11/05/2020
            </td>
            
          </tr>
          
        </table>
      </mat-card>

      
    </mat-expansion-panel>
  </mat-accordion>
</div>










</div>





<ng-template #addFolderDialog>
  <h2 matDialogTitle>Add Folder</h2>
  <mat-dialog-content>
    <form  class="example-form">
      <mat-form-field class="example-full-width">
        <mat-label>Folder Name</mat-label>
        <input
          matInput
          placeholder="Folder Name"
         
        />
      </mat-form-field>

      <mat-form-field>
        <mat-label>Select Template</mat-label>
        <mat-select>
          <mat-option value="1">Template 1</mat-option>
        </mat-select>
      </mat-form-field>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions
    align="start"
    fxLayout="row"
    fxLayoutAlign="space-between center"
  >
    <button mat-button  color="basic" >
      Cancel
    </button>
    <button
      mat-button
      color="primary"
     
    >
      Add
    </button>
  </mat-dialog-actions>
</ng-template>